// extracted by mini-css-extract-plugin
module.exports =  {"fields":"fzptAR","gaps":"lRurhD","time":"DSZg3H","mobile":"UACvva"};